module.exports = __webpack_public_path__ + "static/img/粉末丁腈.71b7640.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/粉末丁腈.jpg
// module id = 192
// module chunks = 1